import { useQuery } from '@tanstack/react-query';

import {
  getAccountingPeriodsByYear,
  getAccountingPeriodsByYearAndMonth,
} from './accountingPeriod';
import type { AccountingPeriodsResponse } from './accountingPeriod.types';
import { ACCOUNTING_PERIODS_KEY } from './constants';

export const useGetAccountingPeriods = (year: number, startMonth?: number) => {
  const { data, ...restProps } = useQuery<AccountingPeriodsResponse>({
    queryKey: [ACCOUNTING_PERIODS_KEY, year, startMonth],
    queryFn: () => {
      if (startMonth !== undefined) {
        return getAccountingPeriodsByYearAndMonth(year, startMonth);
      }
      return getAccountingPeriodsByYear(year);
    },
  });

  return { data, ...restProps };
};
